<!-- <button class="toggle-bg-btn" style="position:absolute; right:0" (click)="toggleFooterBg()">Switch Ligh/Dark</button> -->
<div class="why-choose-area pt-4 pb-3 footer-wrapper"
  [ngStyle]="{'background-color': footerBackgroundColor}">

    <div class="container-footer">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-sm-12 col-md-12">
                <div class="text-center">
<ng-container *ngIf="!currentBanner; else footerImageBlock">
    <p><b>{{resource.footer_element}}</b></p>
    <!-- <p>{{resource.business_inquiries}} <a> {{resource.mail}} </a></p> -->
    <p>
      {{resource.business_inquiries}}
      <a class="colorLink" href="mailto:consult@scanfluence.com">{{resource.mail}}</a>
    </p>
  </ng-container>

    <ng-template #footerImageBlock>
    <div *ngIf="currentBanner" class="footer-cover" [ngStyle]="{'--bg-image': footerBannerStyle}" role="img" aria-label="Footer banner">
      <div class="footer-blue-overlay" aria-hidden="true"></div>

      <img
        class=""
        [src]=""
        [alt]="resource.footer_image_alt || 'Footer banner'"
        loading="lazy"
        (error)="currentBanner = null; footerBannerStyle = null;" />
    </div>
  </ng-template>

            <!-- <div class="col-lg-6 col-sm-6 col-md-6 pb-3">
                <div class="single-why-choose-box" *ngIf="showInstallBox" (click)="onClickInstall()">
                    <i class='bx bx-archive'></i>
                    <span>{{resource.footer_install_heading1}}</span>
                </div>
            </div> -->
        </div>
        <div class="why-choose-content">
            <!-- <h3>{{resource.footer_heading2}}</h3>
            <div *ngIf="showLoginElement">
                <div *ngIf="!isLoggedIn"><a routerLink="/login" class="default-btn">{{resource.signIn}}</a></div>
                <div *ngIf="!isLoggedIn">{{resource.new_customer}}? <a routerLink="/register">{{resource.signUp}}</a>
                </div>
            </div>
        </div>
    <div class="mt-3 text-center font-size">
      <span>📢 <b>{{resource.footer_heading}} </b></span>
    </div>

    <div class="mt-3 col-sm-12 text-center footerEnd">
      <b>{{resource.visit}} <a href="https://www.Scanfluence.com" target="_blank" rel="noopener noreferrer" class="colorLink">
   {{resource.footer_siteName}}</a>
    {{resource.contact_site}} <a href="mailto:consult@scanfluence.com"  target="_blank" rel="noopener noreferrer" class="colorLink" >{{resource.footer_site}}</a>
   </b> </div>
        <!-- <div class="text-center col-sm-7 offset-md-3" style="display :inline-flex;">
            <div><img src="assets/img/quick-tips.png" /></div>
            <div style="margin: auto 0px;">
                {{resource.footer_quicktip_heading}} <b><a routerLink="quick-tips">{{resource.click_here}}</a></b></div>
        </div>
    </div> -->
</div>
<div class="footer-wrapper">
<footer class="footer-area footer-container">
    <!-- <div class="container">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-md-12">
                <div class="single-footer-widget" *ngFor="let Content of singleFooterWidget;">
                    <a routerLink="/" class="logo d-inline-block">
                        <img [src]="Content.logo" alt="image">
                    </a>
                    <p>Claim savings instantly or add to wish list for a friendly reminder. </p>
                    <p><b>Oh!</b> By the way, have fun playing games for Free</p>
                    <p>For easy access Click <i class='bx bx-archive px-1'></i> <span
                            (click)="onClickInstall()">‘Install’</span> to save right on your
                        mobile screen
                    </p>
                    <p>{{Content.paragraph}}</p>
                    <ul class="social-links">
                        <li><a href="#" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                        <li><a href="#" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                    </ul> 
                </div>
            </div>

            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-footer-widget pl-4">
                   <h3>Useful Links</h3>
                    <ul class="links-list">
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                        <li><a routerLink="/customer-service">Return Policy</a></li>
                        <li><a routerLink="/term-condition">Terms & Conditions</a></li>
                        <li><a routerLink="/how-it-works">How It Works?</a></li>
                        <li><a routerLink="/faq">FAQs</a></li>
                    </ul> 
                </div>
            </div> 

            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-footer-widget">
                    <h3>Popular Store</h3>
                    <ul class="links-list">
                        <li><a routerLink="/stores">Excavator</a></li>
                        <li><a routerLink="/stores">The Bird</a></li>
                        <li><a routerLink="/stores">Triple One</a></li>
                        <li><a routerLink="/stores">Hi-Tech</a></li>
                    </ul>
                </div>
            </div> 

            <div class="col-lg-4 col-sm-4 col-md-4">
                <div class="single-footer-widget">
                    <h3>Contact Info</h3>
                    <ul class="footer-contact-info">
                        <li>Address: 3600 Steeles Avenue East Markham, ON, L3R 9Z7, Canada</li>
                        <li>Email: <a href="mailto:hello@scanfluence.com">hello@scanfluence.com</a></li>
                        <li>Phone: <a href="tel:+44587154756">+44 587 154756</a></li>
                        <li>Fax: <a href="tel:+55587154756">+55 587 154756</a></li>
                    </ul>
                </div>
            </div> 
        </div>
    </div> -->

    <div class="copyright-area">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="copyright-container">
                <ul>
                  <li><a routerLink="/privacy-policy">{{resource.privacy_policy}}</a></li>
                  <li><a routerLink="/term-condition">{{resource.term_conditions}}</a></li>
                  <li><a routerLink="/contact">{{resource.contact_us}}</a></li>
                </ul>
                <p>
                 {{resource.copy_right}} 2026 - {{resource.powered_by}}
                  <strong>Scanfluence Software Inc.</strong>
                </p>
                <!-- <p>Copyright @{{ marxaYear }} <strong>Scanfluence</strong> is Proudly Powered by <a href="#"
                            target="_blank">Scanfluence</a></p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      
</footer>
</div>